import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import BodyTypeSelector from '../../containers/exterior-view/BodyTypeSelector';
import GradeSelector from '../../containers/exterior-view/GradeSelector';
import ColorSelector from '../../containers/exterior-view/ColorSelector';
import ColorInfo from '../../containers/exterior-view/ColorInfo';
import EstimateLink from '../../containers/exterior-view/EstimateLink';
import AccessorySelector from '../../containers/exterior-view/AccessorySelector';
import Viewer from '../../containers/exterior-view/Viewer';
import ModalWindow from '../../components/modal-window';
import './styles.css';
//import * as model from "../../utils";
import {scrollToNode} from '../../utils';
import BodyControl from "../../components/body";
import {IS_MOBILE} from "../../constants/environment";
import {getCookie, isEqualId} from "../utilities";
import ScrollLoader from '../../components/scroll-loader';

/**
 *  ExteriorView
 */
class ExteriorView extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    format: PropTypes.string,
    hideEstimationButton: PropTypes.bool,
    title: PropTypes.string,
    colorInformation: PropTypes.string,
    backgroundSrc: PropTypes.string,
    mbBackgroundSrc: PropTypes.string,
    estimationDisplay: PropTypes.string,
    description: PropTypes.string,
    accessoryLabel: PropTypes.string,
    accessoryDetail: PropTypes.string,
    accessories: PropTypes.arrayOf(PropTypes.node),
    models: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        nameJa: PropTypes.string,
        bodyTypes: PropTypes.arrayOf(
          PropTypes.shape({
            default: PropTypes.bool,
            carId: PropTypes.string,
            bodyTypeModel: PropTypes.string,
            tabName: PropTypes.string,
            generations: PropTypes.arrayOf(
              PropTypes.shape({
                default: PropTypes.bool,
                carTypeCode: PropTypes.string,
                exteriorViewDefaultGradeId: PropTypes.string,
                grades: PropTypes.arrayOf(
                  PropTypes.shape({
                    default: PropTypes.bool,
                    gradeId: PropTypes.string,
                    gradeName: PropTypes.string,
                    gradeCode: PropTypes.string,
                    specialCar: PropTypes.bool,
                    fuel: PropTypes.string,
                    engine: PropTypes.string,
                    defaultDrive: PropTypes.string,
                    defaultMission: PropTypes.string,
                    colors: PropTypes.arrayOf(
                      PropTypes.shape({
                        default: PropTypes.bool,
                        code: PropTypes.string,
                        name: PropTypes.string,
                        price: PropTypes.string,
                        taxPrice: PropTypes.string,
                        rgb: PropTypes.string,
                      }),
                    ),
                  }),
                ),
              }),
            )},
          ),
        )},
      ),
    ),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    format: null,
    hideEstimationButton: null,
    title: null,
    colorInformation: null,
    backgroundSrc: null,
    mbBackgroundSrc: null,
    estimationDisplay: null,
    description: null,
    accessoryLabel: null,
    accessoryDetail: null,
    accessories: null,
    models: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    if (!this.props.models) return;
    //
    //console.log(JSON.stringify(this.props));
    //console.log(this.props);
    //
    const defaultModel = this.getDefaultModel();
    const defaultBodyType = this.getDefaultBodyType();
    const defaultGeneration = this.getDefaultGeneration();
    const defaultGrade = this.getDefaultGrade();
    const defaultColor = this.getDefaultColor();
    //
    this.state = {
      currentModelId: (defaultModel) ? defaultModel.name : null,
      currentBodyTypeId: (defaultBodyType) ? defaultBodyType.carId : null,
      currentGenerationId: (defaultGeneration) ? defaultGeneration.carTypeCode : null,
      currentGradeId: (defaultGrade) ? defaultGrade.gradeId : null,
      //currentGradeCode: defaultGrade.gradeCode,
      currentColorId: (defaultColor) ? defaultColor.code : null,
      //angle: 0,
      colorPrice: (defaultColor) ? defaultColor.price : null,
      colorTaxPrice: (defaultColor) ? defaultColor.taxPrice : null,
      colorName: (defaultColor) ? defaultColor.name : null,
      selectedAccessoryIndexList: '',
      selectedAccessoryIdList: [],
      isOpenedGradeSelector: false,
      isOpenedAccessorySelector: false,
      gradeSelectorHeight: 0,
      backgroundSrc: this.props.backgroundSrc,
    };
    
    //
    this.accessorySelectorRef = React.createRef();
    
  }
  
  componentDidMount() {
    if (!this.props.models) return;
    if (!this.state.currentModelId || !this.state.currentBodyTypeId || !this.state.currentGenerationId || !this.state.currentGradeId || !this.state.currentColorId) return null;
    //console.log('ExteriorView : componentDidMount');
    window.addEventListener('resize', this.handleResize);
    setTimeout(() => {
      this.handleResize();
    }, 500);
    // 背景
    if (IS_MOBILE === true && this.props.mbBackgroundSrc && this.props.mbBackgroundSrc !== '') {
      this.setState({
        backgroundSrc: this.props.mbBackgroundSrc,
      })
    }
  
    // URLパラメータでダイレクト遷移
    this.setCurrentByParams();

  }
  
  componentWillUnmount() {
    if (!this.props.models) return;
    if (!this.state.currentModelId || !this.state.currentBodyTypeId || !this.state.currentGenerationId || !this.state.currentGradeId || !this.state.currentColorId) return null;
    window.removeEventListener('resize', this.handleResize);
  }
  
  changeBodyType(model) {
    
    model = this.getBodyTypeId(model);
    
    //console.log('changeBodyType: ' + model);
    this.setState({
      currentBodyTypeId: model,
      currentGenerationId: this.getCarTypeCode(model),
    });
    // ボディータイプを切り替えた際に選択済みグレードがボディータイプにない場合の処理
    let gradeInfo = this.getGradeInfo(model);
    if (this.props.format === 'Select-Bodytype') {
      let i, max;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].default === true) {
          this.changeGrade(model, gradeInfo[i].gradeId);
          return;
        }
      }
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        // if (gradeInfo[i].gradeId === this.state.currentGradeId) {
        if (isEqualId(gradeInfo[i].gradeId, this.state.currentGradeId)) {
          this.changeGrade(model, gradeInfo[i].gradeId);
          return;
        }
      }
    } else {
      let i, max;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        // if (gradeInfo[i].gradeId === this.state.currentGradeId) {
        if (isEqualId(gradeInfo[i].gradeId, this.state.currentGradeId)) {
          this.changeGrade(model, gradeInfo[i].gradeId);
          return;
        }
      }
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].default === true) {
          this.changeGrade(model, gradeInfo[i].gradeId);
          return;
        }
      }
    }
    this.changeGrade(model, gradeInfo[0].gradeId);
  }
  
  changeGrade(model, gradeId) {
    //console.log('changeGrade: ' + gradeId);
    this.setState({
      currentGradeId: gradeId,
    });
    // グレードを切り替えた際に選択済みカラーがボディタイプない場合の処理
    let colorInfo = this.getColorInfo(model, gradeId);
    let i, max;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].code === this.state.currentColorId) {
        this.changeColor(model, gradeId, colorInfo[i].code);
        return;
      }
    }
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].default === true) {
        this.changeColor(model, gradeId, colorInfo[i].code);
        return;
      }
    }
    this.changeColor(model, gradeId, colorInfo[0].code);
  }
  
  changeColor(model, gradeId, code) {
    //console.log('changeColor: ' + code);
    let colorPrice = null;
    let colorTaxPrice = null;
    let colorName = null;
    let colorInfo = this.getColorInfo(model, gradeId);
    let i, max;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].code === code) {
        colorPrice = colorInfo[i].price;
        colorTaxPrice = colorInfo[i].taxPrice;
        colorName = colorInfo[i].name;
        break;
      }
    }
    //
    this.setState({
      currentColorId: code,
      colorPrice: colorPrice,
      colorTaxPrice: colorTaxPrice,
      colorName: colorName,
    })
  }
  
  changeAccessories(indexList, idList) {
    //console.log('changeAccessories');
    this.setState({
      selectedAccessoryIndexList: indexList.join(','),
      selectedAccessoryIdList: idList,
    });
  }
  
  showColorInfo(model, gradeId, code) {
    //console.log('showColorInfo');
    let colorInfo = this.getColorInfo(model, gradeId);
    let i, max;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].code === code) {
        this.setState({
          colorPrice: colorInfo[i].price,
          colorTaxPrice: colorInfo[i].taxPrice,
          colorName: colorInfo[i].name,
        });
        break;
      }
    }
  }
  
  hideColorInfo() {
    //console.log('hideColorInfo');
    let colorInfo = this.getColorInfo(this.state.currentBodyTypeId, this.state.currentGradeId);
    let i, max;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].code === this.state.currentColorId) {
        this.setState({
          colorPrice: colorInfo[i].price,
          colorTaxPrice: colorInfo[i].taxPrice,
          colorName: colorInfo[i].name,
        });
        break;
      }
    }
  }
  
  openAccessoryDetail() {
    //console.log('openAccessoryDetail');
    this.refs.modalWindow.open();
  }
  
  closeAccessoryDetail() {
    //console.log('closeAccessoryDetail');
    this.refs.modalWindow.close();
  }
  
  openGradeSelector() {
    //console.log('openGradeSelector');
    this.setState({
      isOpenedGradeSelector: true,
    });
  }
  
  closeGradeSelector() {
    //console.log('closeGradeSelector');
    this.setState({
      isOpenedGradeSelector: false,
    });
  }
  
  openAccessorySelector() {
    this.setState({
      isOpenedAccessorySelector: true,
    });
    //
    BodyControl.scrollToNode(this.refs.accessory);
  };
  
  closeAccessorySelector() {
    this.setState({
      isOpenedAccessorySelector: false,
    });
    //
    BodyControl.scrollToNode(this.refs.heading);
  };
  
  render() {
    if (!this.props.models) return null;
    if (!this.state.currentModelId || !this.state.currentBodyTypeId || !this.state.currentGenerationId || !this.state.currentGradeId || !this.state.currentColorId) return null;
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      format,
      hideEstimationButton,
      title,
      colorInformation,
      backgroundSrc,
      mbBackgroundSrc,
      estimationDisplay,
      description,
      accessoryLabel,
      accessoryDetail,
      accessories,
      models,
    } = this.props;
    
    // タイトル
    const renderTitle = () => {
      if (title && title !== '') {
        return (
          <div className="ExteriorView__heading Wysiwyg"
               ref="heading"
               dangerouslySetInnerHTML={{__html: title}}
          />
        )
      } else {
        return null;
      }
    };
    
    // ナビゲーション
    const renderNavigation = () => {
      if (format === 'Select-Grade') {
        // 全て選択可能
        return (
          <div className="ExteriorView__navigation"
               ref="navigation"
          >
            <BodyTypeSelector
              bodyTypeInfo={this.getBodyTypeInfo()}
              currentBodyTypeId={this.state.currentBodyTypeId}
              changeBodyType={(model) => {
                this.changeBodyType(model);
              }}
            />
            <GradeSelector
              open={this.state.isOpenedGradeSelector}
              gradeInfo={this.getGradeInfo(this.state.currentBodyTypeId)}
              currentGradeId={this.state.currentGradeId}
              changeGrade={(gradeId) => {
                this.changeGrade(this.state.currentBodyTypeId, gradeId);
              }}
              openGradeSelector={() => {
                this.openGradeSelector();
              }}
              closeGradeSelector={() => {
                this.closeGradeSelector();
              }}
              contentHeight={this.state.gradeSelectorHeight}
              currentBodyTypeId={this.state.currentBodyTypeId}
            />
          </div>
        )
      } else if (format === 'Select-Bodytype') {
        // ボディタイプのみ選択可能
        const gradeName = this.getGradeName(this.state.currentBodyTypeId, this.state.currentGradeId);
        return (
          <div className="ExteriorView__navigation"
               ref="navigation"
          >
            <BodyTypeSelector
              bodyTypeInfo={this.getBodyTypeInfo()}
              currentBodyTypeId={this.state.currentBodyTypeId}
              changeBodyType={(model) => {
                this.changeBodyType(model);
              }}
            />
            <p className="ExteriorView__navigation__paragraph">{gradeName}</p>
            {/*<p className="ExteriorView__navigation__paragraph">{this.state.currentGradeId}</p>*/}
          </div>
        )
      } else if (format === 'Single-Grade') {
        const gradeName = this.getGradeName(this.state.currentBodyTypeId, this.state.currentGradeId);
        // グレード固定
        return (
          <div className="ExteriorView__navigation"
               ref="navigation"
          >
            <p className="ExteriorView__navigation__paragraph">
              {gradeName}
            </p>
          </div>
        )
      } else {
        return null;
      }
    };
    
    // ビューアー
    const renderViewer = () => {
      return (
        <Viewer
          modelId={this.state.currentModelId}
          bodyTypeId={this.state.currentBodyTypeId}
          generationId={this.state.currentGenerationId}
          gradeId={this.state.currentGradeId}
          colorId={this.state.currentColorId}
          accessoryIndexList={this.state.selectedAccessoryIndexList}
          //angle={this.state.angle}
        />
      )
    };
    
    // アクセサリ選択
    const renderAccessorySelector = () => {
      return (
        <AccessorySelector
          open={this.state.isOpenedAccessorySelector}
          accessoryLabel={accessoryLabel}
          colorInfo={this.getColorInfo(this.state.currentBodyTypeId, this.state.currentGradeId)}
          currentColorId={this.state.currentColorId}
          openAccessoryDetail={() => {
            this.openAccessoryDetail();
          }}
          closeAccessoryDetail={() => {
            this.closeAccessoryDetail();
          }}
          openAccessorySelector={() => {
            this.openAccessorySelector();
          }}
          closeAccessorySelector={() => {
            this.closeAccessorySelector();
          }}
          changeAccessories={(indexList, idList) => {
            this.changeAccessories(indexList, idList);
          }}
          ref={this.accessorySelectorRef}
        >
          {accessories}
        </AccessorySelector>
      )
    };
    
    // カラー選択
    const renderColorSelector = () => {
      return (
        <ColorSelector
          colorInfo={this.getColorInfo(this.state.currentBodyTypeId, this.state.currentGradeId)}
          currentColorId={this.state.currentColorId}
          changeColor={(code) => {
            this.changeColor(this.state.currentBodyTypeId, this.state.currentGradeId, code);
          }}
          showColorInfo={(code) => {
            this.showColorInfo(this.state.currentBodyTypeId, this.state.currentGradeId, code);
          }}
          hideColorInfo={() => {
            this.hideColorInfo();
          }}
        />
      )
    };
    
    // カラー情報
    const renderColorInfo = () => {
      return (
        <ColorInfo
          name={this.state.colorName}
          colorInformation={colorInformation}
          price={this.state.colorPrice}
          taxPrice={this.state.colorTaxPrice}
        />
      )
    };
    
    // 見積もりボタン
    const renderEstimationLink = () => {
      if (hideEstimationButton === false) {
        const estimateInfo = this.getEstimateInfo(this.state.currentBodyTypeId, this.state.currentGradeId);
        return (
          <EstimateLink
            carId={this.state.currentBodyTypeId}
            carTypeCode={this.getCarTypeCode(this.state.currentBodyTypeId)}
            estimationDisplay={estimationDisplay}
            gradeId={this.state.currentGradeId}
            gradeCode={estimateInfo.gradeCode}
            engine={estimateInfo.engine}
            drive={estimateInfo.drive}
            mission={estimateInfo.mission}
            colorId={this.state.currentColorId}
            accessoryIdList={this.state.selectedAccessoryIdList}
          />
        )
      } else {
        return null;
      }
    };
    
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <ScrollLoader>
          <div
            className="ExteriorView"
            ref="content"
          >
            <div className="ExteriorView__container"
                 style={(this.state.backgroundSrc && this.state.backgroundSrc !== '') ? {backgroundImage: 'url(' + this.state.backgroundSrc + ')'}: null}
            >
              
              {renderTitle()}
              
              {renderNavigation()}
              
              <div ref="viewer">
                
                {renderViewer()}
              
              </div>
            
            </div>
            <div className="ExteriorView__container2" ref="accessory">
              {(this.state.isOpenedAccessorySelector === true) ?
                <a
                  className="ExteriorView__link-close"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.closeAccessorySelector();
                    this.accessorySelectorRef.current.clearAccessoryIndex();
                  }}
                >CLOSE</a>
              : null}
              {renderAccessorySelector()}
            </div>
            <div className="ExteriorView__container3"
                 style={(this.state.isOpenedAccessorySelector === true) ? {display: 'none'}: null}
            >
              
              {renderColorSelector()}
              
              {renderColorInfo()}
              
              {renderEstimationLink()}
              
              {(description && description !== '') ?
                <p className="ExteriorView__description Wysiwyg" dangerouslySetInnerHTML={{__html: description}}/>
                : null}
            
            </div>
            <div
              className={'ExteriorView__overlay' + ((this.state.isOpenedAccessorySelector === true || this.state.isOpenedGradeSelector === true) ? ' open': '')}/>
            <ModalWindow
              type={'Light'}
              ref={'modalWindow'}
            >
              <div className="ExteriorView__accessory-detail Wysiwyg"
                   dangerouslySetInnerHTML={{__html: accessoryDetail}}/>
            </ModalWindow>
          </div>
        </ScrollLoader>
      </Wrapper>
    )
  }
  
  //
  handleResize = () => {
    if (!this.refs.content || !this.refs.navigation) return;
    this.setState({
      gradeSelectorHeight: this.refs.content.offsetHeight - this.refs.navigation.offsetTop - 55,
    });
  };
  
  //
  getBodyTypeInfo = () => {
    if (this.props.models[0].bodyTypes && Array.isArray(this.props.models[0].bodyTypes) && 1 <= this.props.models[0].bodyTypes.length) {
      return this.props.models[0].bodyTypes;
    }
    return [];
  };
  
  //
  getBodyTypeId = (currentBodyTypeId) => {
    let bodyTypeInfo = this.getBodyTypeInfo();
    let i, max;
    for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
      if (isEqualId(bodyTypeInfo[i].carId, currentBodyTypeId)) {
        return bodyTypeInfo[i].carId;
      }
    }
    for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
      if (bodyTypeInfo[i].default === true) {
        return bodyTypeInfo[i].carId;
      }
    }
    return bodyTypeInfo[0].carId;
  };
  
  //
  getGradeInfo = (currentBodyTypeId) => {
    let bodyTypeInfo = this.getBodyTypeInfo();
    let i, max;
    for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
      // if (bodyTypeInfo[i].carId === currentBodyTypeId) {
      if (isEqualId(bodyTypeInfo[i].carId, currentBodyTypeId)) {
        return bodyTypeInfo[i].generations[0].grades;
      }
    }
    for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
      if (bodyTypeInfo[i].default === true) {
        return bodyTypeInfo[i].generations[0].grades;
      }
    }
    return bodyTypeInfo[0].generations[0].grades;
  };
  
  //
  getGradeName = (currentBodyTypeId, currentGradeId) => {
    let gradeInfo = this.getGradeInfo(currentBodyTypeId);
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      // if (gradeInfo[i].gradeId === currentGradeId) {
      if (isEqualId(gradeInfo[i].gradeId, currentGradeId)) {
        // 特別仕様車の場合はgradeIdを採用する
        if (gradeInfo[i].specialCar === true) {
          return gradeInfo[i].gradeId;
        } else {
          return (gradeInfo[i].gradeName && gradeInfo[i].gradeName !== '') ? gradeInfo[i].gradeName : gradeInfo[i].gradeId;
        }
      }
    }
    return null;
  };
  
  //
  getColorInfo = (currentBodyTypeId, currentGradeId) => {
    let gradeInfo = this.getGradeInfo(currentBodyTypeId);
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      // if (gradeInfo[i].gradeId === currentGradeId) {
      if (isEqualId(gradeInfo[i].gradeId, currentGradeId)) {
        return gradeInfo[i].colors;
      }
    }
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      if (gradeInfo[i].default === true) {
        return gradeInfo[i].colors;
      }
    }
    return gradeInfo[0].colors;
  };
  
  //
  getEstimateInfo = (currentBodyTypeId, currentGradeId) => {
    let gradeInfo = this.getGradeInfo(currentBodyTypeId);
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      // if (gradeInfo[i].gradeId === currentGradeId) {
      if (isEqualId(gradeInfo[i].gradeId, currentGradeId)) {
        return {
          gradeId: gradeInfo[i].gradeId,
          gradeCode: gradeInfo[i].gradeCode,
          engine: gradeInfo[i].engine,
          drive: gradeInfo[i].defaultDrive,
          mission: gradeInfo[i].defaultMission,
        }
      }
    }
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      if (gradeInfo[i].default === true) {
        return {
          gradeId: gradeInfo[i].gradeId,
          gradeCode: gradeInfo[i].gradeCode,
          engine: gradeInfo[i].engine,
          drive: gradeInfo[i].defaultDrive,
          mission: gradeInfo[i].defaultMission,
        }
      }
    }
    return {
      gradeId: gradeInfo[0].gradeId,
      gradeCode: gradeInfo[0].gradeCode,
      engine: gradeInfo[0].engine,
      drive: gradeInfo[0].defaultDrive,
      mission: gradeInfo[0].defaultMission,
    }
  };
  
  //
  getCarTypeCode = (currentBodyTypeId) => {
    let bodyTypeInfo = this.getBodyTypeInfo();
    let i, max;
    for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
      // if (bodyTypeInfo[i].carId === currentBodyTypeId) {
      if (isEqualId(bodyTypeInfo[i].carId, currentBodyTypeId)) {
        return bodyTypeInfo[i].generations[0].carTypeCode;
      }
    }
    for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
      if (bodyTypeInfo[i].default === true) {
        return bodyTypeInfo[i].generations[0].carTypeCode;
      }
    }
    return bodyTypeInfo[0].generations[0].carTypeCode;
  };
  
  // デフォルトモデル取得
  getDefaultModel = () => {
    if (this.props.models[0]) {
      return this.props.models[0];
    }
    return null;
  };
  
  // デフォルト世代取得
  getDefaultGeneration = () => {
    let bodyTypeInfo = this.getBodyTypeInfo();
    let i, max;
    for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
      if (bodyTypeInfo[i].default === true) {
        return bodyTypeInfo[i].generations[0];
      }
    }
    return bodyTypeInfo[0].generations[0];
  };
  
  // デフォルトボディタイプ取得
  getDefaultBodyType = () => {
    let bodyTypeInfo = this.getBodyTypeInfo();
    let i, max;
    for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
      if (bodyTypeInfo[i].default === true) {
        return bodyTypeInfo[i];
      }
    }
    return bodyTypeInfo[0];
  };
  
  // デフォルトグレード取得
  getDefaultGrade = () => {
    let gradeInfo = this.getGradeInfo(this.getDefaultBodyType().models);
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      if (gradeInfo[i].default === true) {
        return gradeInfo[i];
      }
    }
    return gradeInfo[0];
  };
  
  // デフォルトカラー取得
  getDefaultColor = () => {
    const models = this.getDefaultBodyType().models;
    const gradeId = this.getGradeInfo(models).gradeId;
    let colorInfo = this.getColorInfo(models, gradeId);
    let i, max;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].default === true) {
        return colorInfo[i];
      }
    }
    return colorInfo[0];
  };
  
  // URLパラメータでダイレクト遷移
  setCurrentByParams = ()=> {
  
    if (this.props.format === 'Single-Grade') return;
    
    const setCurrent = (bodyTypeId, gradeId = null)=> {
    
      // BodyType情報取得
      const getBodyTypeInfo = ()=> {
        let i, max;
        for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
          let j, max2;
          for (j = 0, max2 = this.props.models[i].bodyTypes.length; j < max2; j = j + 1) {
            // if (this.props.models[i].bodyTypes[j].carId === bodyTypeId) {
            if (isEqualId(this.props.models[i].bodyTypes[j].carId, bodyTypeId)) {
              return this.props.models[i].bodyTypes[j];
            }
          }
        }
        return null;
      };
      const bodyTypeInfo = getBodyTypeInfo();
      
      if (bodyTypeInfo && gradeId) {
      
        // グレード情報取得
        const getGradeInfo = ()=> {
          let i, max;
          for (i = 0, max = bodyTypeInfo.generations.length; i < max; i = i + 1) {
            let j, max2;
            for (j = 0, max2 = bodyTypeInfo.generations[i].grades.length; j < max2; j = j + 1) {
              // if (bodyTypeInfo.generations[i].grades[j].gradeId === gradeId) {
              if (isEqualId(bodyTypeInfo.generations[i].grades[j].gradeId, gradeId)) {
                return bodyTypeInfo.generations[i].grades[j];
              }
            }
          }
          return null;
        };
        const gradeInfo = getGradeInfo();
        if (gradeInfo) {
          
          // BodyType及びグレードが存在した場合
          this.changeBodyType(bodyTypeId);
          this.changeGrade(bodyTypeId, gradeId);
          
        } else {
  
          // BodyTypeのみ存在した場合
          this.changeBodyType(bodyTypeId);
          
        }
      } else {
  
        // BodyTypeのみ存在した場合
        this.changeBodyType(bodyTypeId);
  
      }
      
    };
  
    if (this.props.format === 'Select-Bodytype') {
      
      // URLパラメータでカレント変更
      let carId = BodyControl.getUrlParameter('car_id');
      if (carId) {
        setCurrent(carId);
      } else {
        // ブロックのCookieに保温されている値でカレント変更
        carId = getCookie('mj_360bt');
        if (carId) {
          setCurrent(carId);
        } else {
          // 車種サイトのCookieに保温されている値でカレント変更
          carId = getCookie('mjcarid');
          if (carId) {
            setCurrent(carId);
          }
        }
      }
      
    } else {
      
      // URLパラメータでカレント変更
      let carId = BodyControl.getUrlParameter('car_id');
      let gradeId = BodyControl.getUrlParameter('grade');
      if (carId || gradeId) {
        if (carId && gradeId) {
          setCurrent(carId, gradeId);
        } else if (carId) {
          setCurrent(carId);
        }
      } else {
        // ブロックのCookieに保温されている値でカレント変更
        carId = getCookie('mj_360bt');
        gradeId = getCookie('mj_360gr');
        if (carId || gradeId) {
          if (carId && gradeId) {
            setCurrent(carId, gradeId);
          } else if (carId) {
            setCurrent(carId);
          }
        } else {
          // 車種サイトのCookieに保温されている値でカレント変更
          carId = getCookie('mjcarid');
          if (carId) {
            setCurrent(carId);
          }
        }
      }
      
    }
  
  };
  
}

export default ExteriorView;



// WEBPACK FOOTER //
// ./src/containers/exterior-view/index.jsx